<modal-layout-right [titleShadow]="false">
    <p class="h3"
       modalTitle></p>
    <div modalBody
         class="p-t-7 p-a-6">
        <p class="p1">{{'1. Upload your own design' | translate}}</p>
        <p class="c1 col-11 m-t-2">{{'JPEG or PNGs accepted; 7 MB max. Image ratio is 2:3.' | translate}}</p>

        <div class="w-12 ratio-3-2 m-t-8 bg-col-4">
            <p class="pos-absolute top-4 left-50 col-11">{{'Preview window' | translate}}</p>
            <div class="pos-absolute top-50 left-50"
                 style="width: 62%; transform: translate(-50%, -50%);">
                <div class="ratio-3-2 w-12 overflow-hidden"
                     style="border-radius: 5px; box-shadow: 0px 4px 34px 0px rgba(0, 0, 0, 0.15);">
                    @if (data.previewImage && !imageSrc) {
                    <img class="fill"
                         [image]="data.previewImage" />
                    } @else if (canvaBase64) {
                    <div class="fill"
                         [style]="'width: 100%; height: 100%; background-image: url(' + canvaBase64 + '); background-size: cover; background-position: center;'">
                    </div>
                    }
                </div>
            </div>
            <file-input style="opacity: 0;"
                        [accept]="'.jpg,.jpeg,.png'"
                        [maxSize]="'7M'"
                        (fileChange)="onFileChange($event)"></file-input>
        </div>
        <div class="flex-column flex-middle m-t-5">
            @if(!canvaBase64) {
            <div class="pos-relative">
                <action class="button"
                        [class.busy]="uploadButtonStatus.busy">
                    <span class="flex flex-middle"><i class="icon-download inline-flex m-r-3"
                           style="font-size: 24px;"></i>{{'Drag or upload your image' | translate}}</span>
                </action>
                <file-input style="opacity: 0;"
                            [accept]="'.jpg,.jpeg,.png'"
                            [maxSize]="'7M'"
                            (fileChange)="onFileChange($event)"></file-input>
            </div>
            } @else {
            <action class="button"
                    [class.busy]="uploadButtonStatus.busy">
                <span (click)="confirm()">{{'Confirm design' | translate}}</span>
            </action>
            <p class="p3 m-t-2">{{'or' | translate}} <span class="underline pos-relative cursor-pointer">
                    {{'reupload design' | translate}}
                    <file-input style="opacity: 0;"
                                [accept]="'.jpg,.jpeg,.png'"
                                [maxSize]="'7M'"
                                (fileChange)="onFileChange($event)"></file-input></span></p>

            }

            <result [status]="uploadButtonStatus"></result>
        </div>
    </div>
</modal-layout-right>